import { render, staticRenderFns } from "./TasksSite.vue?vue&type=template&id=6d3fd9f8"
import script from "./TasksSite.vue?vue&type=script&lang=js"
export * from "./TasksSite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports